<template>
  <NuxtLink :to="`/${locale}`" class="logo">
    <img
      src="/images/logo/logo-new.svg"
      alt="Sola Scriptura"
      width="150"
      height="50"
      loading="eager"
      decoding="async"
      class="logo-img"
    >
  </NuxtLink>
</template>

<script setup lang="ts">
const { locale } = useI18n()
</script>

<style scoped>
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  max-width: 150px;
}

.logo-img {
  display: block;
  width: 303px;
  height: auto;
}

@media (max-width: 480px) {
  .logo-img {
    width: 100px;
  }
}
</style>
